interface FilterSortBarProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
  sortOrder: "latest" | "oldest" | "title";
  onSortChange: (order: "latest" | "oldest" | "title") => void;
  sortLabelPrefix?: string;
}

export default function FilterSortBar({
  categories,
  activeCategory,
  onCategoryChange,
  sortOrder,
  onSortChange,
  sortLabelPrefix = "排序",
}: FilterSortBarProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 bg-background-100 border border-background-200 rounded-lg p-3 md:p-2">
      <div className="flex flex-wrap gap-2 px-1 py-1">
        {categories.map((cat) => (
          <button
            key={cat}
            type="button"
            onClick={() => onCategoryChange(cat)}
            className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
              activeCategory === cat
                ? "bg-primary-500 text-background-50 font-medium"
                : "bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-2 px-2 md:pr-2">
        <span className="text-xs text-foreground-500 whitespace-nowrap hidden sm:inline">
          {sortLabelPrefix}
        </span>
        <select
          value={sortOrder}
          onChange={(e) => onSortChange(e.target.value as "latest" | "oldest" | "title")}
          className="text-sm bg-background-50 border border-background-300 rounded-md px-3 py-2 text-foreground-700 cursor-pointer outline-none focus:border-primary-400"
        >
          <option value="latest">最新发布</option>
          <option value="oldest">最早发布</option>
          <option value="title">标题排序</option>
        </select>
      </div>
    </div>
  );
}